module.exports = __webpack_public_path__ + "img/app-yly.1aea1255.webp";